// Product Header Section JavaScript

document.addEventListener('DOMContentLoaded', function() {
  // Check if we are on a product page with our sliders
  if (!document.querySelector('.product-slider')) {
    return;
  }

  // Device detection for different behaviors
  const isMobile = window.innerWidth < 768;

  // Hide initial product image that's shown during loading
  function hideInitialImage() {
    const initialImage = document.querySelector('.initial-product-image');
    if (initialImage) {
      initialImage.style.opacity = '0';
      setTimeout(() => {
        initialImage.style.display = 'none';
      }, 300);
    }
  }

  // Hide loader overlay when carousels are ready
  function hideLoaderOverlay() {
    const loaderOverlay = document.querySelector('.carousel-loader-overlay');
    if (loaderOverlay) {
      loaderOverlay.classList.add('loaded');
      setTimeout(() => {
        loaderOverlay.style.display = 'none';
      }, 500);
    }
    hideInitialImage();
    setTimeout(() => {
      activateZoom(true);
    }, 2000);
  }

  function activateZoom(reset = false){
    // Create and manage image popup functionality
    $('.zoomable').each(function() {
      // Remove any existing click handlers if resetting
      if(reset){
        $(this).off('click');
      }
      
      // Get the image source
      const imageElement = $(this).find('img');
      const zoomUrl = imageElement.data('lazy') || imageElement.attr('src');
      
      // Add click handler to create popup
      $(this).on('click', function(e) {
        // Don't open popup if clicking on size-info-container
        if ($(e.target).closest('.size-info-container').length) {
          return;
        }
        
        // Create popup elements
        const popup = $('<div class="image-popup-overlay"></div>');
        const popupContent = $('<div class="image-popup-content"></div>');
        const popupImage = $('<img src="' + zoomUrl + '" alt="Full size image">');
        const closeButton = $('<button class="image-popup-close">&times;</button>');
        
        // Add styles inline to ensure they're applied
        popup.css({
          'position': 'fixed',
          'top': '0',
          'left': '0',
          'width': '100%',
          'height': '100%',
          'background-color': 'rgba(0, 0, 0, 0.8)',
          'z-index': '9999',
          'overflow': 'hidden'
        });
        
        popupContent.css({
          'position': 'relative',
          'width': '100%',
          'height': '100%',
          'overflow': 'hidden'
        });
        
        
        // Adjust close button position for mobile
        if (window.innerWidth < 768) {
          popupImage.css({
            'position': 'absolute',
            'min-width': '200%', // Zoomed in
            'height': 'auto',
            'top': '0',
            'left': '0',
            'transform': 'translate(-25%, 0)',
            'cursor': 'move'
          });
          closeButton.css({
            'position': 'absolute',
            'top': '10px',
            'right': '10px',
            'font-size': '30px',
            'color': 'white',
            'background': 'rgba(0, 0, 0, 0.5)',
            'border': 'none',
            'border-radius': '50%',
            'width': '40px',
            'height': '40px',
            'line-height': '45px',
            'text-align': 'center',
            'cursor': 'pointer',
            'z-index': '10000'
          });
        } else {
          popupImage.css({
            'position': 'absolute',
            'width': '200%', // Zoomed in
            'height': 'auto',
            'top': '0',
            'left': '0',
            'transform': 'translate(0, 0)',
            'cursor': 'move'
          });
          closeButton.css({
            'position': 'absolute',
            'top': '10px',
            'right': '10px',
            'font-size': '30px',
            'color': 'white',
            'background': 'rgba(0, 0, 0, 0.5)',
            'border': 'none',
            'border-radius': '50%',
            'width': '40px',
            'height': '40px',
            'line-height': '45px',
            'text-align': 'center',
            'cursor': 'pointer',
            'z-index': '10000'
          });
        }
        
        // Assemble and append popup to body
        popupContent.append(popupImage);
        popupContent.append(closeButton);
        popup.append(popupContent);
        $('body').append(popup);
        
        // Handle image panning on desktop OR mobile drag detection
        let isDragging = false;
        let startX, startY, startTranslateX = 0, startTranslateY = 0;
        let didMove = false; // Flag to detect movement between touchstart and touchend

        // Add click handler to image to close popup
        popupImage.on('click', function(e) {
          // Only close if no movement occurred during the touch interaction (mobile)
          // On desktop, this condition doesn't apply, so it will always close.
          // We rely on the fact that didMove is only set to true in the mobile touchmove handler.
          if (!didMove) { 
            popup.remove();
            // Ensure Escape key listener is also removed
            $(document).off('keydown.imagePopup'); 
          }
          // Note: didMove doesn't need explicit reset here, as it's reset on the next touchstart
        });
        
        if (window.innerWidth >= 768) {
          // Desktop mouse move behavior
          popupContent.on('mousemove', function(e) {
            const containerWidth = popupContent.width();
            const containerHeight = popupContent.height();
            const imageWidth = popupImage.width();
            const imageHeight = popupImage.height();
            
            // Calculate max translation to keep image within bounds
            const maxTranslateX = Math.max(0, imageWidth - containerWidth);
            const maxTranslateY = Math.max(0, imageHeight - containerHeight);
            
            // Calculate percentage position of mouse in container
            const mouseXPercent = e.clientX / containerWidth;
            const mouseYPercent = e.clientY / containerHeight;
            
            // Calculate translation based on mouse position
            const translateX = -maxTranslateX * mouseXPercent;
            const translateY = -maxTranslateY * mouseYPercent;
            
            // Apply translation
            popupImage.css('transform', `translate(${translateX}px, ${translateY}px)`);
          });
        } else {
          // Mobile touch behavior
          popupContent.on('touchstart', function(e) {
            isDragging = true;
            didMove = false; // Reset move flag on new touch start
            startX = e.originalEvent.touches[0].clientX;
            startY = e.originalEvent.touches[0].clientY;
            
            // Get current transform values
            const transform = popupImage.css('transform');
            const matrix = transform.match(/^matrix\((.+)\)$/);
            if (matrix) {
              const values = matrix[1].split(', ');
              startTranslateX = parseInt(values[4]) || 0;
              startTranslateY = parseInt(values[5]) || 0;
            }
            
            // Don't prevent default here, allow potential scroll before drag starts
            // e.preventDefault(); 
          });
          
          popupContent.on('touchmove', function(e) {
            if (!isDragging) return;
            didMove = true; // Movement detected
            
            const currentX = e.originalEvent.touches[0].clientX;
            const currentY = e.originalEvent.touches[0].clientY;
            const deltaX = currentX - startX;
            const deltaY = currentY - startY;
            
            const containerWidth = popupContent.width();
            const containerHeight = popupContent.height();
            const imageWidth = popupImage.width();
            const imageHeight = popupImage.height();
            
            // Calculate new translation with boundaries
            let newTranslateX = startTranslateX + deltaX;
            let newTranslateY = startTranslateY + deltaY;
            
            // Apply boundaries
            newTranslateX = Math.min(0, Math.max(newTranslateX, containerWidth - imageWidth));
            newTranslateY = Math.min(0, Math.max(newTranslateY, containerHeight - imageHeight));
            
            popupImage.css('transform', `translate(${newTranslateX}px, ${newTranslateY}px)`);
            
            e.preventDefault(); // Prevent page scroll ONLY when dragging the image
          });
          
          popupContent.on('touchend', function() {
            // Reset dragging state, didMove retains its value until next touchstart
            isDragging = false;
          });
        }
        
        // Handle closing the popup
        closeButton.on('click', function() {
          popup.remove();
        });
        
        popup.on('click', function(e) {
          if (e.target === this) {
            popup.remove();
          }
        });
        
        // Close on escape key
        $(document).on('keydown.imagePopup', function(e) {
          if (e.key === 'Escape') {
            popup.remove();
            $(document).off('keydown.imagePopup');
          }
        });
      });
    });
  }

  // Expose the function globally so it can be called when slick loads
  window.initProductHeaderSliders = function() {
    if (typeof jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined') {
      initProductSliders(jQuery);
    }
  };

  // Wait for jQuery and slick to be available
  const initCarousels = function() {
    if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
      setTimeout(initCarousels, 100);
      return;
    }
    
    const $ = jQuery;
    initProductSliders($);
  };

  // Initialize product sliders
  function initProductSliders($) {
    // Function to adjust thumbnail height to match main image height
    function adjustThumbnailHeight() {
      if (isMobile) return; // Only apply on desktop
      
      const mainImageContainer = $('.header-carousel img:first-child');
      const thumbnailCarousel = $('.thumbnails-carousel');
      
      if (mainImageContainer.length && thumbnailCarousel.length) {
        const mainImageHeight = mainImageContainer.height();
        
        if (mainImageHeight > 0) {
          thumbnailCarousel.css('height', mainImageHeight + 'px');
          
          // Also update the slick list and track heights
          $('.thumbnails-carousel .slick-list').css('height', mainImageHeight + 'px');
          
          // Re-position thumbnails slider after height change
          if (thumbnailSlider) {
            thumbnailSlider.slick('setPosition');
          }
        }
      }
    }
    
    // Main product slider settings
    const productSliderSettings = {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: false,
      infinite: false,
      lazyLoad: 'progressive', // Enable lazy loading
      initialSlide: 0,
      prevArrow: $('.prev-slide'),
      nextArrow: $('.next-slide'),
      // Only set asNavFor for desktop
      //asNavFor: isMobile ? null : '.thumbnails-slider',
      // Add swipe for mobile
      swipe: isMobile ? true : false,
      // Add dots for mobile
      dots: isMobile ? false : false,
      // Handle loading events
      onInit: function(slick) {
        // Preload first 5 slides
        const slidesToPreload = Math.min(5, slick.slideCount);
        for (let i = 0; i < slidesToPreload; i++) {
          const slide = $(slick.$slides[i]);
          const img = slide.find('img');
          if (img.data('lazy')) {
            img.attr('src', img.data('lazy'));
          }
        }
        
        // Show swipe hint for mobile
        if (isMobile) {
          const swipeHint = document.querySelector('.mobile-swipe-hint');
          if (swipeHint) {
            swipeHint.style.display = 'block';
            // Hide swipe hint after 3 seconds
            setTimeout(() => {
              swipeHint.style.opacity = '0';
              setTimeout(() => {
                swipeHint.style.display = 'none';
              }, 500);
            }, 3000);
          }
        }
        
        // Hide loading overlay after a short delay
        setTimeout(hideLoaderOverlay, 500);
        
        // Adjust thumbnail height after initialization
        if (!isMobile) {
          setTimeout(adjustThumbnailHeight, 300);
        }

      }
    };

    // Store all product slides for filtering by color
    let allProductSlides = [];

    // Store all slides for later filtering by color
    $('.product-slider .slide-item').each(function(index) {
      allProductSlides.push($(this).clone());
    });

    // Initialize product slider
    const productSlider = $('.product-slider').slick(productSliderSettings);
    
    // Handle image load events to adjust height
    if (!isMobile) {
      $('.product-slider img').on('load', function() {
        setTimeout(adjustThumbnailHeight, 100);
      });
    }
    
    // Only initialize thumbnail slider on desktop
    var thumbnailSlider;
    var thumbnailSliderSettings;
    
    if (!isMobile && document.querySelector('.thumbnails-slider')) {
      // Thumbnail slider settings for desktop
        thumbnailSliderSettings = {
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '.product-slider',
            dots: false,
            focusOnSelect: true,
            vertical: true,
            verticalSwiping: false,
            centerMode: false,
            swipeToSlide: false,
            infinite: false,
            arrows: true,
            draggable: true,
            swipe: true,
            prevArrow: $('.prev-thumbnail'),
            nextArrow: $('.next-thumbnail'),
            responsive: [
                {
                    breakpoint: 1135, // tablet breakpoint
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 1385, // tablet breakpoint
                    settings: {
                        slidesToShow: 5
                    }
                },
                {
                    breakpoint: 1500,
                    settings: {
                        slidesToShow: 6
                    }
                },
                {
                    breakpoint: 1620,
                    settings: {
                        slidesToShow: 7
                    }
                },
                {
                    breakpoint: 1740,
                    settings: {
                        slidesToShow: 8
                    }
                },
                {
                    breakpoint: 1860,
                    settings: {
                        slidesToShow: 9
                    }
                },
                {
                    breakpoint: 1980,
                    settings: {
                        slidesToShow: 10
                    }
                }
            ]
        };
      
      // Store all thumbnail slides
      var allThumbnailSlides = [];
      
      $('.thumbnails-slider .thumbnail-item').each(function(index) {
        allThumbnailSlides.push($(this).clone());
      });
      
      // Initialize thumbnail slider
      thumbnailSlider = $('.thumbnails-slider').slick(thumbnailSliderSettings);
      
      // Make sure the thumbnails slider is properly initialized as vertical
      thumbnailSlider.slick('setPosition');
      
      // Flag to track if we're coming from a thumbnail click
      let fromThumbnailClick = false;

      // Handle thumbnail click
      $(document).on('click', '.thumbnails-slider .thumbnail-item', function() {
        const index = $(".product-slider .slide-item[data-position="+$(this).data('position')+"]").data('slickIndex');
        fromThumbnailClick = true;
        productSlider.slick('slickGoTo', index);
      });

      // Handle product slider change
      /*productSlider.on('afterChange', function(event, slick, currentSlide) {
        if (!fromThumbnailClick) {
          thumbnailSlider.slick('slickGoTo', currentSlide);
        }
        fromThumbnailClick = false;
        
        // Adjust height after slide change
        adjustThumbnailHeight();
      });*/
    }

    // Handle lazyload events
    productSlider.on('lazyLoaded', function(event, slick, image, imageSource) {
      // Add animation or transition when image is loaded
      $(image).addClass('loaded');
      
      // Adjust height when images load
      if (!isMobile) {
        setTimeout(adjustThumbnailHeight, 100);
      }
    });

    // Function to filter slides by color variant
    const filterSlidesByColor = function(color) {
      // Show loading overlay
      /*
      const loaderOverlay = document.querySelector('.carousel-loader-overlay');
      if (loaderOverlay) {
        loaderOverlay.style.display = 'flex';
        loaderOverlay.classList.remove('loaded');
      }
      */
      
      if (isMobile) {
        // For mobile: just navigate to the first image of the color but keep all images
        if (window.tabImageCarousel && window.tabImageCarousel[color] && window.tabImageCarousel[color].length > 0) {
          // Get the first index for this color
          const firstIndex = window.tabImageCarousel[color][0];
          // Navigate to that slide
          productSlider.slick('slickGoTo', firstIndex);
          
          // Hide loading overlay after a short delay
          setTimeout(hideLoaderOverlay, 300);
        } else {
          // If no color-specific images defined, just hide the loader
          hideLoaderOverlay();
        }
      } else {
        // For desktop: filter slides by color
        if (window.tabImageCarousel && window.tabImageCarousel[color]) {
          // Unslick sliders
          productSlider.slick('unslick');
          if (thumbnailSlider) thumbnailSlider.slick('unslick');

          // Clear sliders
          $('.product-slider').empty();
          if (!isMobile) $('.thumbnails-slider').empty();

          // Get indexes of images for this color
          const colorIndexes = window.tabImageCarousel[color];
          
          // Add slides for this color
          colorIndexes.forEach(function(index) {
            $('.product-slider').append(allProductSlides[index].clone());
            if (!isMobile && allThumbnailSlides[index]) {
              $('.thumbnails-slider').append(allThumbnailSlides[index].clone());
            }
          });

          // Reinitialize sliders
          $('.product-slider').slick(productSliderSettings);
          if (!isMobile) {
            $('.thumbnails-slider').slick(thumbnailSliderSettings);
            
            // Adjust thumbnail height after color change
            setTimeout(adjustThumbnailHeight, 500);
          }
        }
        
        // Hide loading overlay after a short delay
        setTimeout(hideLoaderOverlay, 500);
      }
      if(!isMobile){
        loadAltDescCarousel();
      }
    };
    
    // Make filterSlidesByColor available globally
    window.filterSlidesByColor = filterSlidesByColor;

    // Color swatch selection logic
    $('.swatches-selector[data-name=Couleur] .swatch').on('click', function() {
      const colorValue = $(this).attr('data-value');
      
      // Filter slides by color
      filterSlidesByColor(colorValue);
      
      // Update price based on selected variant
      updateVariantPrice();
      
    });

    // Initialize with selected color variant
    setTimeout(function() {
      if (window.tabImageCarousel && window.tabImageCarousel[window.selectedVariantOnLoad]) {
        filterSlidesByColor(window.selectedVariantOnLoad);
      } else {
        // If no color-specific images, hide the loader anyway
        hideLoaderOverlay();
      }
      if(isMobile){
        loadAltDescCarousel();
      }
      
      // Initial height adjustment
      if (!isMobile) {
        setTimeout(adjustThumbnailHeight, 500);
      }
    }, 200);

    // Responsive adjustments
    const adjustLayout = function() {
      // Reset device detection on resize
      const newIsMobile = window.innerWidth < 768;
      
      if (newIsMobile !== isMobile && newIsMobile) {
        // If switched to mobile, reload page to apply mobile layout
        // This is a simple approach - in production you might want a more sophisticated solution
        window.location.reload();
      }
      
      if (window.innerWidth >= 768) {
        // For desktop view with vertical thumbnails
        if (thumbnailSlider) {
          $('.thumbnails-slider').css({
            "top": "0px"
          });
          
          // Adjust thumbnail height on resize
          adjustThumbnailHeight();
        }
      } else {
        // Revert to default styles for mobile
        if (thumbnailSlider) {
          $('.thumbnails-slider').css({
            "top": "",
            "width": "",
            "left": ""
          });
        }
      }
    };
    
    // Adjust on load and resize
    setTimeout(adjustLayout, 300);
    $(window).on('resize', adjustLayout);
    
    // Make the adjustThumbnailHeight function globally available
    window.adjustThumbnailHeight = adjustThumbnailHeight;
  }

  // Function to update available sizes based on color
  function updateAvailableSizes(color) {
    const sizeOptions = document.querySelectorAll('.size-option');
    sizeOptions.forEach(option => {
      const sizeValue = option.getAttribute('data-value');
      const variantKey = color + " / " + sizeValue;
      const variantId = window.corresp_color_size_id[variantKey];

      if (variantId && window.variant_info_full[variantId]) {
        if (window.variant_info_full[variantId].available) {
          option.classList.remove('disabled');
        } else {
          option.classList.add('disabled');
        }
      } else {
        option.classList.add('disabled');
      }
    });

    // Select first available size
    const firstAvailableSize = document.querySelector('.size-option:not(.disabled)');
    if (firstAvailableSize) {
      sizeOptions.forEach(btn => btn.classList.remove('selected'));
      firstAvailableSize.classList.add('selected');

      // Update variant selection
      const colorValue = color;
      const sizeValue = firstAvailableSize.getAttribute('data-value');
      const variantId = window.corresp_color_size_id[colorValue + " / " + sizeValue];

      // Update form value
      const variantInput = document.querySelector('input[name="id"]');
      if (variantInput) {
        variantInput.value = variantId;
      } else {
        // If input doesn't exist, create it
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'id';
        input.value = variantId;
        document.querySelector('.add-to-cart-section').appendChild(input);
      }

      // Update stock indicators
      const variantKey = colorValue + "_" + sizeValue;
      const variantInventory = window.realVariantStocks[variantId];
      const isAvailable = window.variant_info_full[variantId].available;
      const inventoryPolicy = window.variant_info_full[variantId].inventory_policy;
      const preorderLimit = window.variant_preorder_limits[variantKey];
      const restockDate = window.txt_variant_restock[variantKey];
      const preorderDate = window.txt_variant_preorder_delivery_date[variantKey];

      window.handleStockIndicationProductPage(variantInventory, restockDate, isAvailable, inventoryPolicy, preorderLimit, preorderDate);
    }
  }

  // Start initialization
  initCarousels();
});

// Function to update price when variant changes
function updateVariantPrice() {
  const selectedColorElem = document.querySelector('.swatches-selector[data-name=Couleur] .selected');
  const selectedSizeElem = document.querySelector('.size-option.selected');
  
  if (!selectedColorElem) return;
  
  const colorValue = selectedColorElem.getAttribute('data-value');
  let variantId;
  
  if (window.hasSize && selectedSizeElem) {
    const sizeValue = selectedSizeElem.getAttribute('data-value');
    const variantKey = colorValue + " / " + sizeValue;
    variantId = window.corresp_color_size_id[variantKey];
  } else {
    // For products with only color option
    variantId = window.corresp_color_size_id[colorValue];
  }
  
  if (!variantId || !window.variant_prices || !window.variant_prices[variantId]) return;
  
  const priceInfo = window.variant_prices[variantId];
  const priceContainer = document.querySelector('.product-price');
  const gfPriceContainer = document.querySelector('.gf_product-price');
  const comparePrice = priceContainer.querySelector('.compare-price');
  const currentPrice = priceContainer.querySelector('.current-price');
  
  // Update the current price
  if (currentPrice) {
    currentPrice.textContent = priceInfo.price;
  }

  if (gfPriceContainer) {
    gfPriceContainer.dataset.price = (parseFloat(priceInfo.price.replace(/[^0-9.-]+/g, '')) * 100);
  }
  
  // Handle compare price (sale price)
  if (priceInfo.compare_at_price && parseInt(priceInfo.compare_at_price.replace(/[^0-9.-]+/g, '')) > parseInt(priceInfo.price.replace(/[^0-9.-]+/g, ''))) {
    // Show compare price if it's higher than the current price
    if (comparePrice) {
      comparePrice.textContent = priceInfo.compare_at_price;
      comparePrice.style.display = 'inline';
    } else {
      // Create compare price element if it doesn't exist
      const newComparePrice = document.createElement('span');
      newComparePrice.className = 'compare-price';
      newComparePrice.textContent = priceInfo.compare_at_price;
      priceContainer.insertBefore(newComparePrice, currentPrice);
    }
  } else {
    // Hide compare price if there is no sale
    if (comparePrice) {
      comparePrice.style.display = 'none';
    }
  }

  // Adjust thumbnail height after variant change (for desktop only)
  if (window.innerWidth >= 768 && window.adjustThumbnailHeight) {
    setTimeout(window.adjustThumbnailHeight, 300);
  }

  setAlmaPrice();
}

// Make updateVariantPrice available globally
window.updateVariantPrice = updateVariantPrice;
